import { render, staticRenderFns } from "./Pricing2.vue?vue&type=template&id=52cc2c8b&"
import script from "./Pricing2.vue?vue&type=script&lang=js&"
export * from "./Pricing2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports